
import { mapState } from "vuex";

export default {
  props: {
    hierarchicalMenu: { type: Array, default: () => [] },
    mobileBanner: { type: Object, default: () => {} },
    mobileBannerLink: { type: Object, default: () => {} },
  },

  data() {
    return {
      sidebarMode: false,
      menuReady: false,
      cachedMenuItems: null,
      resizeHandler: null,
      initialHeight: null,
    };
  },

  computed: {
    ...mapState("app", ["activeMenuIndex", "isMegaMenuOpen"]),
    showMobileBanner() {
      return this.$device.isMobileOrTablet && this.isMegaMenuOpen;
    },
    menuItems() {
      return this.hierarchicalMenu.map(({ collection, hasChildren }) => ({
        ...collection.primary,
        hasChildren,
      }));
    },
  },

  watch: {
    isMegaMenuOpen(newVal) {
      if (!newVal) {
        this.$refs["mega-menu-top"]?.scrollTo({
          top: 0,
          left: 0,
        });
      }
    },
  },

  mounted() {
    const width = window.innerWidth;

    if (width <= 1100) {
      this.sidebarMode = true;
      this.menuReady = true;
      return;
    }

    const container = this.$refs["mega-menu-top"];
    if (!container) {
      this.menuReady = true;
      return;
    }

    const detectWrap = () => {
      if (this.sidebarMode || !this.cachedMenuItems?.length) return;

      const firstTop = this.cachedMenuItems[0].offsetTop;
      const lastTop =
        this.cachedMenuItems[this.cachedMenuItems.length - 1].offsetTop;

      if (firstTop !== lastTop) {
        this.sidebarMode = true;
        this.$emit("sidebar-mode", true);
      }
    };

    this.$nextTick(() => {
      /* freeze height before detection */
      this.initialHeight = container.offsetHeight;

      /* cache menu items */
      this.cachedMenuItems = container.querySelectorAll("a, button");

      /* tiny improvement — wait one frame so Vue fully renders */
      requestAnimationFrame(() => {
        detectWrap();

        this.menuReady = true;

        this.resizeHandler = detectWrap;
        window.addEventListener("resize", this.resizeHandler);
      });
    });
  },

  beforeDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
    }
  },
};
